var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoIdiomaBanderas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 203.44 180.4",
    style: {
      enableBackground: "new 0 0 203.44 180.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2D31FA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Language_translator_00000054983001313183253710000012956838851105259940_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.41,127.96c2.08-2.16,4.03-4.43,5.86-6.8h-11.72C129.37,123.53,131.33,125.8,133.41,127.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.61,76.83h-57V12.79c0-3.5-2.83-6.33-6.33-6.33c0,0,0,0,0,0H27.83c-3.5,0-6.33,2.83-6.33,6.33c0,0,0,0,0,0 v84.44c0,3.5,2.83,6.33,6.33,6.33c0,0,0,0,0,0h57v64.04c0,3.5,2.83,6.33,6.33,6.33c0,0,0,0,0,0h84.44c3.5,0,6.33-2.83,6.33-6.33 c0,0,0,0,0,0V83.16C181.94,79.67,179.11,76.83,175.61,76.83C175.61,76.83,175.61,76.83,175.61,76.83z M93.31,69.78L75.72,34.59 c-2.15-4.29-9.18-4.29-11.33,0L46.8,69.78c-1.56,3.13-0.29,6.93,2.83,8.5c3.13,1.56,6.93,0.29,8.5-2.83l0,0l1.77-3.54h20.32 l1.77,3.54c0.91,1.8,2.64,3.05,4.63,3.36c-1.14,1.17-1.77,2.73-1.78,4.36v7.74H34.16V19.13h71.78v57.7H92.33 C94.08,74.91,94.47,72.11,93.31,69.78z M73.88,59.24h-7.65l3.83-7.66L73.88,59.24z M158.02,121.16h-3.37 c-3.36,5.45-7.28,10.54-11.7,15.17c4.27,3.18,8.94,5.8,13.88,7.79c3.25,1.28,4.86,4.95,3.58,8.21c-1.28,3.25-4.95,4.86-8.21,3.58 c-0.01,0-0.02-0.01-0.03-0.01c-6.75-2.71-13.07-6.37-18.78-10.87c-5.71,4.5-12.03,8.16-18.78,10.87c-0.74,0.3-1.53,0.45-2.33,0.45 c-3.5,0-6.33-2.84-6.33-6.33c0-2.6,1.58-4.93,4-5.89c4.94-1.99,9.61-4.6,13.89-7.78c-4.42-4.64-8.35-9.73-11.71-15.19h-3.37 c-3.5,0-6.33-2.84-6.33-6.34c0-3.5,2.83-6.33,6.33-6.33h18.3v-7.74c0-3.5,2.84-6.33,6.34-6.33c3.5,0,6.33,2.83,6.33,6.33v7.74h18.3 c3.5,0,6.33,2.84,6.33,6.34C164.34,118.33,161.51,121.16,158.02,121.16L158.02,121.16z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoIdiomaBanderas);
export default __webpack_public_path__ + "static/media/ico_idioma_banderas.14f1fbdbdd6542fb9c8f67fec47645a6.svg";
export { ForwardRef as ReactComponent };